// extracted by mini-css-extract-plugin
module.exports = {"desktop":"deckHeader_desktop__fXh_w","mobile":"deckHeader_mobile__tsm4w"};